module.exports = __webpack_public_path__ + "img/step_02.46536943.jpg";